// src/services/NotificationService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { Notification } from "../models/Notification";
import { db } from "../firebase";

const notificationCollectionRef = collection(db, "notifications");

export const NotificationService = {
  async getNotification(notificationId: string): Promise<Notification | null> {
    const notificationDoc = await getDoc(
      doc(notificationCollectionRef, notificationId),
    );
    if (notificationDoc.exists()) {
      return {
        _id: notificationDoc.id,
        ...notificationDoc.data(),
      } as Notification;
    }
    return null;
  },

  async updateNotification(
    notificationId: string,
    updatedData: Partial<Omit<Notification, "_id" | "createdAt">>,
  ): Promise<void> {
    const notificationDocRef = doc(notificationCollectionRef, notificationId);
    await updateDoc(notificationDocRef, {
      ...updatedData,
    });
  },
};
